import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Reload_create_task() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/create_task'); 
  }, [navigate]); 
  return null; 
}
